var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import translationFallback from '../i18n/translations/en-US/waffles.json';
import { ScreenReaderOnly } from '../screen-reader-only';
import { Text } from '../text';
import LevelIndicators from './level-indicators';
import { labelStyle, skillTagStyle } from './styles';
function SkillTag(_a) {
    var { inverted = false, level = 'beginner', size = 'medium', variant = 'primary' } = _a, restProps = __rest(_a, ["inverted", "level", "size", "variant"]);
    const { ready, t } = useTranslation('waffles');
    // Obtain the associated label based on the skill level
    function renderLabel() {
        switch (level) {
            case 'advanced':
                return ready
                    ? t('SkillTag.level.advanced')
                    : translationFallback.SkillTag.level.advanced;
            case 'intermediate':
                return ready
                    ? t('SkillTag.level.intermediate')
                    : translationFallback.SkillTag.level.intermediate;
            case 'beginner':
            default:
                return ready
                    ? t('SkillTag.level.beginner')
                    : translationFallback.SkillTag.level.beginner;
        }
    }
    return (_jsxs("div", Object.assign({}, restProps, { css: skillTagStyle({ inverted }) }, { children: [_jsx(LevelIndicators, Object.assign({}, { level, size, variant })), _jsxs(Text, Object.assign({ css: labelStyle({ size, variant }) }, { children: [renderLabel(), _jsx(ScreenReaderOnly, { children: ready ? t('SkillTag.label') : translationFallback.SkillTag.label })] }))] })));
}
export default SkillTag;
